export const PACKAGE_VERSION = '1.7.17';
//# sourceMappingURL=constants.js.map